<template>
	<div id="app">
		<nav class="navbar">
			<span class="navbar-toggle" id="js-navbar-toggle">
				<font-awesome-icon icon="bars"> </font-awesome-icon>
			</span>

			<span href="#" class="logo flex">
				<router-link to="/register-land" id="mainHeading" class="block text-white hover:text-white mr-4">
					<img id="headerImg" src="https://i.imgur.com/xvzcxlU.png" />
					<!--<img id="headerImg" src="https://i.imgur.com/QAwetDS.png" />-->
				</router-link>
			</span>

			<ul class="main-nav" id="js-menu">
				<li v-if="hasPermission('P_ADD_NEW_CERTIFICATE')">
					<a href="#responsive-header">
						<router-link to="/register-land" class="block text-white hover:text-white mr-4 hover:underline">
							Register land 
						</router-link>
					</a>
				</li>

				<li v-if="hasPermission('P_VIEW_CERTIFICATE_BY_CERTIFIER_ID')">
					<a href="#responsive-header">
						<router-link
							to="/certificates-certifier-dash"
							class="block text-white hover:text-white mr-4 hover:underline"
							>
							Issued Certificates
						</router-link>
					</a>
				</li>

				<li v-if="hasPermission('P_ADD_NEW_TRANSACTION')">
					<a href="#responsive-header">
						<router-link
							to="/create-transaction"
							class="block text-white hover:text-white mr-4 hover:underline"
							>
							Record Transactions
						</router-link>
					</a>
				</li>

				<li v-if="hasPermission('P_VIEW_CERTIFICATE_BY_CERTIFICATE_ID')">
					<a href="#responsive-header">
						<router-link
							to="/certificates-dash"
							class="block text-white hover:text-white mr-4 hover:underline"
							>
							Certificates
						</router-link>
					</a>
				</li>

				<li v-if="hasPermission('P_VIEW_TRANSACTIONS_BY_OWN_ALLOP_ID')">
					<a href="#responsive-header">
						<router-link
							to="/transactions-dash"
							class="block text-white hover:text-white mr-4 hover:underline"
							>
							Transactions
						</router-link>
					</a>
				</li>

				<li>
					<a href="#responsive-header">
						<router-link to="/user/profile" class="block text-white hover:text-white mr-4 hover:underline">
							{{getUsername()}}
						</router-link>
					</a>
				</li>

				<li>
					<a href="#responsive-header">
						<router-link to="/logout" class="block text-white hover:text-white mr-4 hover:underline">
							Logout
						</router-link>
					</a>
				</li>
			</ul>
		</nav>

		<div class="fakeHeader hidden md:block"></div>

		<vue-progress-bar> </vue-progress-bar>

		<SettingsSlider></SettingsSlider>

		<notifications position="top left" group="topLeft"></notifications>
		<notifications position="bottom left" group="bottomLeft"></notifications>
		<notifications position="top right" group="topRight"></notifications>
		<notifications position="bottom right" group="bottomRight"></notifications>
		<notifications position="top center" group="topCenter"></notifications>
		<notifications position="bottom center" group="bottomCenter"></notifications>

	<router-view></router-view>

		<div class="footer bg-black">
			<p class="text-center text-grey text-xs">
			</p>
		</div>
	</div>
</template>

<script>
import "./assets/css/main.css";

import asyncRequest from "./utils/asyncRequest.js";
import SettingsSlider from "./components/SettingsSlider.vue";

export default {
	created() {
		this.current = this.$router.history.current.name;
		this.checkIfUserLoggedIn() 
	},
	mounted() {
		let mainNav = document.getElementById("js-menu");
		let navBarToggle = document.getElementById("js-navbar-toggle");

		navBarToggle.addEventListener("click", function() {
			mainNav.classList.toggle("active");
		});
	},
data() {
		return {
			current: [this.$router.history.current.name],
			mobiMenuItemsShown: false
		};
	},
	methods: {
		checkIfUserLoggedIn() {
			asyncRequest.ServerAPI({
				method: "GET",
				api: this.$store.state.urls.GET_IF_USER_LOGGED_IN,
				onSuccessCallback: dataIn => {
					this.updateLoggedInUserDetails(dataIn);
				},
				postData: null,
				flags: asyncRequest.M_FAIL,
				customSuccessMessage: "",
				customErrorMessage: "",
				beforeAfterCallback: false
			});
		},
		updateLoggedInUserDetails(dataIn) {
			this.$store.commit("userDetails/setUserDetails", {
				value: dataIn.Data
			});
		},
		getUsername(){
			return this.$store.state.userDetails.FirstName
		},
		toggleMobileMenu() {
			this.mobiMenuItemsShown = !this.mobiMenuItemsShown;
		},
		hasPermission(permission) {
			for (var i = 0; i < this.$store.state.userDetails.Permissions.length; i++) {
				if(this.$store.state.userDetails.Permissions[i].PermissionName == permission) {
					return true;
				}
			}
		}
	},
	components: {
		SettingsSlider
	}
};
</script>
<style lang="scss">
#app {
	font-family: "chinese quote", -apple-system, blinkmacsystemfont, "segoe ui", "pingfang sc", "hiragino sans gb",
		"microsoft yahei", "helvetica neue", helvetica, arial, sans-serif, "apple color emoji", "segoe ui emoji",
		"segoe ui symbol" !important;
	font-smooth: always;
	text-align: center;
	color: #2c3e50;
}
.card_shadow {
	box-shadow: 0 3px 8px #d3ddeb;
}
button {
	background-color: rgb(241, 241, 241);
	color: rgb(116, 116, 116);
	padding: 9px 28px;
	border: 1px solid rgb(241, 241, 241);
}
button:hover {
	background-color: #f8f8f8;
	box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
	color: #222223;
	border: 1px solid #c6c6c6;
}
/* v-select overrides */
.v-select .dropdown-toggle {
	border-radius: 0px !important;
}
.v-select .dropdown-toggle {
	border: 1px solid #dae1e7 !important;
}
.v-select .open-indicator::before {
	border-color: #dae1e7 !important;
}
.v-select .dropdown-menu {
	border: 1px solid #dae1e7 !important;
}
.v-select .dropdown-toggle .clear {
	color: #dae1e7 !important;
}
.v-select .selected-tag {
	margin: 0px 2px 0 !important;
}
input {
	border: 1px solid #dae1e7;
	width: 100%;
	height: 100%;
	padding-left: 12px;
}
table {
	color: rgb(50, 57, 79);
	border: 1px solid #e3e3e3;
}
thead {
	border-top: 1px solid #e3e3e3;
	border-bottom: 1px solid #e3e3e3;
}
tr {
	color: rgb(50, 57, 79);
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	border-left: 1px solid #e3e3e3;
	border-right: 1px solid #e3e3e3;
}

tr:last-child > td {
	border-bottom: 1px solid #e3e3e3;
}

tr:hover {
	background-color: rgba(52, 144, 220, 0.1);
}
th {
	font-weight: 300;
	background-color: #f1f1f1;
	text-align: left;
	padding: 15px 10px;
}
th:hover {
	background-color: #d1d1d1;
	transition: background 0.6s ease;
}
td {
	font-weight: 300;
	text-align: left;
	padding: 15px 10px;
	border: 1px solid rgb(250, 250, 252);
}
td:nth-child(1) {
	border-left: 1px #e3e3e3;
}
td:nth-last-child(1) {
	border-right: 1px #e3e3e3;
}
td a {
	color: #3490dc;
	text-decoration: none;
}
td a:hover {
	color: #3490dc;
	text-decoration: underline;
}

/* custom css for date picker*/
.vdp-datepicker__clear-button {
	cursor: pointer;
	position: absolute;
	right: 1%;
	padding-top: 6px;
	color: #dae1e7;
	font-size: 23px;
	font-weight: 700;
	padding: 0;
}
.multiselect__tags {
	border-radius: 0px !important;
	border-color: #dae1e7 !important;
}
body {
	background-color: #fff;
	position: relative;
	margin: 0;
	padding-bottom: 6rem;
	min-height: 100%;
}
.footer {
	position: absolute;
	right: 0;
	bottom: 0;
	left: 0;
	padding: 1rem;
	text-align: center;
}
/*
Override vue-multi select
*/
.multiselect__option--selected.multiselect__option--highlight {
	background: #fbfbfb !important;
	color: #000 !important;
}
.multiselect__option--selected.multiselect__option--highlight:after {
	background: #fbfbfb !important;
	color: #000 !important;
}

/*Top nav menu start*/
.navbar {
	font-size: 18px;
	background-color: #000;
	border: 1px solid rgba(0, 0, 0, 0.2);
	padding-bottom: 10px;
}
.main-nav {
	list-style-type: none;
	display: none;
}
.nav-links,
.logo {
	text-decoration: none;
	color: rgba(255, 255, 255, 0.7);
}
.main-nav li {
	text-align: center;
	margin: 15px auto;
}
li a {
	text-decoration: none;
	font-size: 16px;
}
.logo {
	font-size: 22px;
	margin-top: 10px;
	margin-left: 20px;
	flex-direction: column;
}

.navbar-toggle {
	position: absolute;
	top: 10px;
	right: 20px;
	cursor: pointer;
	color: rgba(255, 255, 255, 0.8);
	font-size: 24px;
}
.active {
	display: block;
}
#mainHeading {
	font-style: italic;
	font-weight: 200;
	font-size: 20px;
	letter-spacing: 0.02em;
	text-decoration: none;
	padding-top: 18px;
}
#headerImg {
	height: 38px;
	margin-right: 13px;
	margin-left: 0;
	margin-bottom: -15px;
	padding-right: 15px;
}
@media screen and (min-width: 1200px) {
	.navbar {
		display: flex;
		justify-content: space-between;
		padding-bottom: 0;
		height: 70px;
		align-items: center;
	}
	.main-nav {
		display: flex;
		margin-right: 30px;
		flex-direction: row;
		justify-content: flex-end;
	}
	.main-nav li {
		margin: 0;
	}
	.nav-links {
		margin-left: 40px;
	}
	.logo {
		flex-direction: row;
		margin-top: -8px;
	}
	.navbar-toggle {
		display: none;
	}
	.logo:hover,
	.nav-links:hover {
		color: rgba(255, 255, 255, 1);
	}
	#mainHeading {
		padding-top: 5px;
	}
	#headerImg {
	}
}
/*Top nav menu end*/
</style>
